var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.notifications.length
    ? _c(
        "div",
        { staticClass: "_flex _flexcol _gap-2 _mb-3" },
        _vm._l(_vm.notifications, function (notification) {
          return _c("notification-list-item", {
            key: notification.key,
            attrs: { notification: notification },
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }